import React from 'react';
import { createCustomMessage } from 'react-chatbot-kit';
import { useLocalContext } from '../../containers/SmartSummariesContainer/LocalContext';
import { sendPrompt } from './http';

interface IAvannisMessagePayload {
    isLoading: boolean;
}

const ActionProvider = ({ createChatBotMessage, setState, children }) => {
    // Get content from the context at the top level of the component
    const { content } = useLocalContext();

    // Define the handleInput function
    const handleInput = async (message: string) => {
        try {
            const avannisMessage = createCustomMessage(
                'avannisMessage',
                'avannisMessage',
                {
                    payload: {
                        isLoading: true,
                    } as IAvannisMessagePayload,
                }
            );

            setState((prev: any) => ({
                ...prev,
                messages: [...prev.messages, avannisMessage],
            }));

            // --------- BUILD CSV WITH id + comment ----------
            // Prefer selectedComments if the user selected any; otherwise use all comments
            var list =
                content && content.selectedComments && content.selectedComments.length > 0
                    ? content.selectedComments
                    : (content && content.comments) ? content.comments : [];

            // AFTER (ES5-safe)
            var csvEscape = function (v: any) {
                var s = String(v == null ? '' : v);
                return '"' + s.replace(/"/g, '""') + '"';
            };

            // Header + rows. Use extref if available, else fall back to id.
            var rows = [['survey', 'id', 'comment']];
            for (var i = 0; i < list.length; i++) {
                var c = list[i] || {};
                var surveyValue = String(c.survey != null ? c.survey : '');
                var idValue =
                    (c.extref != null && String(c.extref).length > 0)
                        ? String(c.extref)
                        : String(c.id != null ? c.id : '');
                var commentText = String(c.text != null ? c.text : '');
                rows.push([surveyValue, idValue, commentText]);
            }

            var csvLines: string[] = [];
            for (var r = 0; r < rows.length; r++) {
                var lineParts = [];
                for (var k = 0; k < rows[r].length; k++) {
                    lineParts.push(csvEscape(rows[r][k]));
                }
                csvLines.push(lineParts.join(','));
            }
            const csvContent = csvLines.join('\r\n');

            // TEMP preview: prints the first 6 lines in the console
            try {
                var preview = csvLines.slice(0, 6).join('\n');
                // eslint-disable-next-line no-console
                console.log('[CSV preview]\n' + preview);
            } catch (e) {
                // ignore console errors
            }
            // --------- /BUILD CSV ----------

            // Send the prompt with the message and content
            const res = await sendPrompt(message, new Blob([csvContent], { type: 'text/csv' }));

            // Existing shape: server returns { data: "<json-string>" }
            if (res && (res as any).data) {
                const responseObject = JSON.parse((res as any).data);

                setState((prev: any) => ({
                    ...prev,
                    messages: prev.messages.map((msg: any) => {
                        if (msg.id === avannisMessage.id) {
                            msg.payload = {
                                isLoading: false,
                                message: responseObject.text,
                            };
                        }
                        return msg;
                    }),
                }));
            } else {
                // eslint-disable-next-line no-console
                console.error('Failed to send comments or invalid response format');
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Fetch error:', error);
        }
    };

    return (
        <div>
            {React.Children.map(children, (child: any) => {
                return React.cloneElement(child, {
                    actions: {
                        handleInput,
                    },
                });
            })}
        </div>
    );
};

export default ActionProvider;
